import { Permission } from 'core/types'

import useAccess from './useAccess'

const useHasPermission = (value?: Permission | Array<Permission>) => {
  const access = useAccess(value)

  return access === 'loading' ? undefined : access === 'allowed'
}

export default useHasPermission
